import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';

const NavWrapper = styled.div`
  border-right: 1px solid #e0e0e0;
  @media (max-width: 412px) {
    & > div[data-active='true'] + nav {
      animation: openMobileMenu 0.1s normal forwards linear;
      animation-iteration-count: 1;
    }
  }
  @keyframes openMobileMenu {
    0% {
      transform: translate(0, 0%);
    }
    100% {
      transform: translate(241px, 0%);
    }
  }
`;
const StyledSideBarWrapper = styled.nav`
  min-width: 240px;
  min-height: calc(100vh - 80px);
  float: left;
`;

const BurgerNavButton = styled.div`
  display: none;
  @media (max-width: 412px) {
    position: fixed;
    top: 18px;
    left: 10px;
    display: block;
    width: 20px;
    height: 4px;
    border-radius: 20px;
    background-color: #7fe200;
    margin: 20px 0;

    &:before,
    &:after {
      position: inherit;
      content: '';
      width: 20px;
      height: 4px;
      border-radius: 20px;
      background-color: #7fe200;
    }
    &:before {
      margin-top: -6px;
    }
    &:after {
      margin-top: 6px;
    }
  }
`;

const SideBar = ({ children }: any) => {
  const navigate = useNavigate();
  return (
    <NavWrapper
      onClick={(e: any) => {
        e.target.dataset.active = e.target.dataset.active ? '' : 'true';
      }}
    >
      <BurgerNavButton />
      <StyledSideBarWrapper
        onClick={(e: any) => {
          if (e.target.dataset?.href === e.target.dataset?.location) return;
          const link = e.target.dataset?.href || e.target.dataset?.location;
          if (link) {
            navigate(link);
          }
        }}
      >
        {children}
      </StyledSideBarWrapper>
    </NavWrapper>
  );
};

export default SideBar;
